export default async function during(time) {
  return new Promise((r) => setTimeout(r, time));
}
